import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeliveryTruck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 17,
	viewBox: "0 0 23 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 0h15v3h3.025l3.979 5.685V14h-2.657a3.252 3.252 0 0 1-6.186 0H9.256a3.251 3.251 0 0 1-6.186 0H0V0zm3.07 12a3.251 3.251 0 0 1 6.186 0H13V2H2v10h1.07zM15 10a3.252 3.252 0 0 1 4.347 2h.657V9.315L16.984 5H15v5zm-8.837 1.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm10.09 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z",
		fill: "#111"
	})
});
export default SvgDeliveryTruck;
